@if (autenticado) {
    <mat-toolbar class="barra">
        <span class="barra__marca">Painel Docentes</span>
        <nav class="barra__navegacao">
            <a matButton routerLink="/importacao" routerLinkActive="barra__link--ativo">Importação</a>
            <a matButton routerLink="/ficha-tecnica" routerLinkActive="barra__link--ativo">Ficha técnica</a>
            <a matButton routerLink="/ipca" routerLinkActive="barra__link--ativo">IPCA</a>
            <a matButton routerLink="/configuracoes" routerLinkActive="barra__link--ativo">
                <mat-icon>settings</mat-icon>
                Configurações
            </a>
        </nav>
        <button matButton type="button" (click)="sair()">
            <mat-icon>logout</mat-icon>
            Sair
        </button>
    </mat-toolbar>
}

<main>
    <router-outlet></router-outlet>
</main>
